import { Box } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Outlet, createFileRoute } from '@tanstack/react-router';

import { getCenterLastReportOptions } from '@/module/ResearchCenter';
import { CenterReportBox } from '@/module/ResearchCenter/CenterReportBox';

export const Route = createFileRoute('/_auth/research-center/_research-center')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.researchCenters' },
  },
  loader: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData(getCenterLastReportOptions());
  },
});

function RouteComponent() {
  const { data } = useSuspenseQuery(getCenterLastReportOptions());
  return (
    <Box p="md">
      <CenterReportBox report={data} />
      <Outlet />
    </Box>
  );
}
